	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class DocumentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Document');
	}
	
	loadAll() : Observable<ePM.Logic.DocumentHistory[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.DocumentHistory> {
		return this.myBaseService.save(tempItem, this.url);
	}
	assign(tempItem: ePM.Logic.DocumentHistoryAssign): Observable<boolean> {
		return this.myBaseService.post(tempItem, this.url + "/Assign");
	}
	restore(id: string): Observable<ePM.Logic.DocumentHistory> {
		return this.myBaseService.post(id, this.url + "/Restore");
	}
    getEdit(id: string): Observable<ePM.Logic.DocumentHistory> {
		return this.myBaseService.getEdit(id, this.url);
	}
    get(id: string) : Observable<ePM.Logic.DocumentHistory>{
		return this.myBaseService.get(id, this.url);
	}
    getHistory(id: string): Observable<ePM.Logic.DocumentHistory[]> {
		return this.myBaseService.loadAll(this.url + '/History/' + id);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
}